<template>
	<v-row justify="center">	
		<v-col
			xl   = "10"
			lg   = "10"
			md   = "11"
			sm   = "12"
			xs   = "12"
			cols = "12"
		>
			<v-card outlined>
				<v-card-title
					class = "secondary body-1 pa-1 white--text font-weight-bold text-uppercase"
				>	
					<v-icon
						small
						color  = "white"
						@click = "$router.back()"
					>mdi-arrow-left-circle</v-icon>
					<v-spacer></v-spacer>

					<v-icon
						small
						color  = "white"
						class  = "mx-1"
					>mdi-cog</v-icon>
					<span 
						class  = "mx-2"
					>
						{{ $ml.get(title) }}
					</span>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-row

					>
						<!-- subtitle -->
						<v-col 
							xl 	 = "12"
							lg 	 = "12"
							md 	 = "12"
							sm 	 = "12"
							xs 	 = "12"
							cols = "12"
						>
							
						
							<v-card 
								class="body-2 pa-2 mt-1 pl-4"
							>								
								<v-row
									no-gutters
								>
									<!-- <v-col
										xl="3"
										lg="3"
										md="4"
										sm="5"
										xs="12"
										cols="12"
									>
										
										
									</v-col> -->

									<template
										v-for ="(item_field, idx_info) of info_fields"
									>
											
										<v-col
											:key  = "idx_info"
											:xl   = "item_field.cols.xl"
											:lg   = "item_field.cols.lg"
											:md   = "item_field.cols.md"
											:sm   = "item_field.cols.sm"
											:xs   = "item_field.cols.xs"
											:cols = "item_field.cols.cols"
										>
											<v-text-field
												dense
												outlined
												hide-details
												v-if 		 = "item_field.type == 'text'"
												class 		 = "mx-2"
												:type 		 = "item_field.type"
												:label 		 = "$ml.get(item_field.text)"
												v-model 	 = "info[item_field.key]"
												:placeholder = "item_field.placeholder ? $ml.get(item_field.placeholder) : ''"
											></v-text-field>
											<v-tooltip
												v-if 		 = "item_field.type == 'number' && item_field.tooltip"
												bottom
											>
												<template v-slot:activator="{ on, attrs }">
													<v-text-field
														dense
														outlined
														hide-details
														class 		 = "mx-2"
														:type 		 = "item_field.type"
														:label 		 = "$ml.get(item_field.text)"
														v-model 	 = "info[item_field.key]"
														:placeholder = "item_field.placeholder ? $ml.get(item_field.placeholder) : ''"
														@input 		= "info[item_field.key] = parseInt($event) || 0"
														v-bind="attrs"
														v-on="on"
													></v-text-field>
												</template>
												<span>{{ $ml.get(item_field.tooltip) }}</span>
											</v-tooltip>
											<v-text-field
												dense
												outlined
												hide-details
												v-if 		 = "item_field.type == 'number' && !item_field.tooltip"
												class 		 = "mx-2"
												:type 		 = "item_field.type"
												:label 		 = "$ml.get(item_field.text)"
												v-model 	 = "info[item_field.key]"
												:placeholder = "item_field.placeholder ? $ml.get(item_field.placeholder) : ''"
												@input 		= "info[item_field.key] = parseInt($event) || 0"
											></v-text-field>
											<v-card
												v-if 	= "item_field.type == 'switch'"
												outlined
												class  	= "pa-0"											
											>
												
													<v-switch
														dense 
														class   = "pa-0 my-2 ml-2"
														:label 	= "$ml.get(item_field.text)"
														v-model = "info[item_field.key]"			
														hide-details
														@change = "actions('check_state', info[item_field.key], 'btn')"
													></v-switch>
												
											</v-card>
												<!-- return-object -->							
											<v-select
												dense												
												outlined
												hide-details											
												v-if 		= "item_field.type == 'select'"
												class 		= "mx-2"
												:items 		= "item_field.list"
												:label 		= "$ml.get(item_field.text)"
												v-model 	= "info[item_field.key]"
												item-text 	= "name"
												item-value 	= "name"
												@input 		= "actions('selects_fields', info[item_field.key], item_field.key)"
											></v-select>

											
											<v-menu 
												offset-y 
												bottom 
												:close-on-content-click = "false"
												v-if = "item_field.type == 'picker_color'"

											> 
											    <template v-slot:activator = " { on: menu } ">
													<v-btn
														class 		= "mx-2"
														:color = "info[item_field.key]"	
														v-on = "menu"   
													>
														{{ $ml.get(item_field.text) }}
													</v-btn>
											 	</template>

											 	<v-color-picker 
												 	v-model="info[item_field.key]"
												 	
											 	></v-color-picker>
											</v-menu>
											<v-btn										
												v-show = "show.btn_show"
												v-if   = "item_field.type == 'btn'"
												color  = "primary"
												@click = "actions(btn_alarm)"
												class 		= "mx-2"
											>
												{{ alarm_button_label }}
											</v-btn>
										</v-col>
									</template>
								</v-row>
								
								<v-progress-linear
							      	indeterminate
							      	color  = "primary"
							      	v-show = "loading"
							    ></v-progress-linear>
							</v-card>
						</v-col>

						<!-- Panels -->

						<v-col
							xl 		= "12"
							lg 		= "12"
							md 		= "12"
							sm 		= "12"
							xs 		= "12"
							cols 	= "12"
						>
							<v-expansion-panels accordion>
						      <v-expansion-panel
						        v-for = "(item_panel,idx_panel) of list_panels"
						        :key  = "idx_panel"

						      >
						        <v-expansion-panel-header>
						        	<span
						        		
						        		class = "text-uppercase subtitle-2 font-weight-bold" 
						        	>
						        		
						        		{{ $ml.get(item_panel.text) }}							
								        	{{  
								        		info_panels[item_panel.component] ? 
								        		' - '  : 
								        		''
								        	}}
							        	
							        	<span
							        		:class = "
							        		info_panels[item_panel.component] && 
							        		info_panels[item_panel.component].color ?
							        		' ' + info_panels[item_panel.component].color + '--text caption ml-2 text-capitalize' :
							        		''"
							        	>
							        		{{ 
							        			info_panels[item_panel.component] && 
							        			info_panels[item_panel.component].text ?
							        			' ' + $ml.get(info_panels[item_panel.component].text):
							        			'' 
							        		}}
							        	</span>
						        	</span>
						        	<v-input
									    		     
									    :success-messages = "[info_panels[item_panel.component].message]"					    
									></v-input>
										    <!-- :color    = "info_panels[item_panel.component].color_msg" -->
										    <!-- :messages = "info_panels[item_panel.component].message" -->
						        </v-expansion-panel-header>
						        <v-expansion-panel-content>

						          	<component
						          		:is  			   = "item_panel.component"
						          		v-if  			   = "item_panel.enable"
						          		:info_to_component = "info_compt"
						          		@info_component    = "receive_info($event)"
						          		@update_active_rule = "actions('active_rule', $event)"
						          	></component>
						        </v-expansion-panel-content>
						      </v-expansion-panel>
						    </v-expansion-panels>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>

		</v-col>
	</v-row>
</template>
<script>
	import EventBus 		from '@/event-bus'
	import rules 			from '@/components/alarms/alarm_rules.vue'
	// import alarm_roi 	from '@/components/alarms/alarm_roi.vue'
	// import schedule from '@/components/alerts/table.vue'
	import actions 			from '@/components/alarms/actions.vue'
	// import schedule 		from '@/components/alarms/schedule.vue'
	import devices 			from '@/components/stream/registered_devices.vue'
	import default_alarm	from '@/components/alarms/default_alarm.json'
	export default{
		name: 'settings_alarm',
		components: {
			rules,
			// alarm_roi,
			actions,
			// schedule, 
			devices,
		},
		data: (vm) => ({			
			title: 'settings_smart_event',
			subtitle: {
				device : 'device',
				name   : 'name alarm' 
			},
			info : {
				name_alarm 	: '',
				state  		: true,
				frequency  	: 0,
				smart_event_cooldown_seconds: 0
			},
			info_item  		: {},			
			info_compt 		: {},
			info_local 		: null,
			info_fields : [
				{
					key  		: 'name',
					text 		: 'name',
					type 		: 'text',
					placeholder : 'alarm',
					cols 		: {
						xl 	 : 2,
						lg 	 : 2,
						md 	 : 3,
						sm 	 : 6,
						cols : 12,
					}
				},
				{
					key  		: 'state',
					text 		: 'status',
					type 		: 'switch',
					placeholder : '',
					cols 		: {
						xl 	 : 2,
						lg 	 : 2,
						md 	 : 3,
						sm 	 : 6,
						xs   : 6,
						cols : 12,
					}
 				},
 				{
					key  		: 'sound',
					text 		: 'sound',
					type 		: 'select',
					opt 		: 'sounds',
					placeholder : '',
					list 		: vm.$Sounds.get('array', true), //[ 'alert', 'alert_success'],
					cols 		: {
						xl 	 : 2,
						lg 	 : 2,
						md 	 : 3,
						sm 	 : 6,
						xs   : 6,
						cols : 12,
					}
 				},
 				{
					key  		: 'color',
					text 		: 'color',
					type 		: 'picker_color',
					placeholder : '',
					list 		: ['red', 'blue', 'yellow', 'green', 'orange', 'pink'],
					cols 		: {
						xl 	 : 1,
						lg 	 : 1,
						md 	 : 2,
						sm 	 : 6,
						xs   : 6,
						cols : 12,
					} 	
 				},
 				{
					key  		: 'frequency',
					text 		: 'frequency_smart_event',
					type 		: 'number',
					placeholder : '',
					tooltip 	: 'frequency_smart_event_tooltip',
					cols 		: {
						xl 	 : 2,
						lg 	 : 2,
						md 	 : 3,
						sm 	 : 6,
						xs   : 6,
						cols : 12,
					}
				},
				{
					key  		: 'smart_event_cooldown_seconds',
					text 		: 'smart_event_cooldown_seconds_label',
					type 		: 'number',
					placeholder : '',
					cols 		: {
						xl 	 : 2,
						lg 	 : 2,
						md 	 : 3,
						sm 	 : 6,
						xs   : 6,
						cols : 12,
					}
				},
				{
					key  		: 'btn_alarm',
					text 		: 'save',
					type 		: 'btn',
					placeholder : '',
					cols 		: {
						xl 	 : 2,
						lg 	 : 2,
						md 	 : 3,
						sm 	 : 6,
						xs   : 6,
						cols : 12,
					}
 				}


			],
			btn_alarm 			: 'save',
			show 				: {
				btn_show 			: false,
			},
			list_devices 		: [],
			info_panels 		: {
				devices : {
					color : 'success',
					text  : 'default',
					message 	: '',
					color_msg  	: '',
				},
				rules : {
					color : 'warning',
					text  : 'required_register_one_rule',
					message 	: '',
					color_msg  	: '',
				},
				/*schedule : {
					color : 'success',
					text  : 'Default',
					message 	: '',
					color_msg  	: '',
				},*/
				actions : {
					color : 'success',
					text  : 'default',
					message 	: '',
					color_msg  	: '',
				},

			},
			list_panels 		: [
				{
					title 		: 'Registered devices',
					text 		: "registered_devices",
					component 	: 'devices',
					enable 		: true,
					
				},
				{
					title: 'Rules',
					text 		: "rules",
					component: 'rules',
					enable: true,
					
				},
				/*{
					title: 'Roi',
					component: 'alarm_roi',
					enable: true,
					
				},*/
				/*{
					title: 'Schedule',
					component: 'schedule',
					enable: true,
					
				},*/
				{
					title 		: 'Action',
					text 		: "actions",
					enable 		: true,
					component 	: 'actions',
				}
			],
			alarm_default 	: default_alarm, 
			loading 		: false,
			default_points  : [
				{
					point1:[
						"0.0102",
						"0.0160"
					],
					point2:[
						"0.9918",
						"0.0160"
					],
					point3:[
						"0.9918",
						"0.9840"
					],
					point4:[
						"0.0102",
						"0.9840"
					]

					/*height : 0.9920,
					left   : 0.0051,
					top    : 0.0080,
					width  : 0.9949,*/
				}
			]
		}), // data

		created(){
			let temp_local = this.$Helper.get_local('settings_alarm');
		/*	if (!temp_local){
				temp_local = this.$Helper.get_local('settings_alarm_temp');
			}*/
			if (temp_local && temp_local.id) {
				console.log(temp_local, "INFO TO GET Alarms Setting")
				this.info_local =  { ...temp_local};
				this.get_list(temp_local.id);
			}else
			if (this.alarm_default) {
				if (temp_local == 'new') {
					this.alarm_default = {	
						"name_alarm" : "",
						"state"  	 : true,
						"color" 	 : "",
						"sound" 	 : "",
						"frequency"   : 0,
						"smart_event_cooldown_seconds": 0,
						"devices" 	 : [],
						"is_active_rules" : true,
						"rules"   	 : [
							
						],
						
						"actions"  	 : {
							"ismodal" 			: true,
							"isnotificable" 	: true,
							"issendtows" 		: true,
							"issendemail" 		: true,
							"issound" 			: true
						}
					}
				}
				// this.check_info();
				let list_devices  = []; 

				// add if not exist default
				if (this.alarm_default && this.alarm_default.devices && this.alarm_default.devices.length === 0) {
					list_devices = this.render_device_default([]);
					// console.log(list_devices, "RENDER DEVICES ")
					this.alarm_default.devices = list_devices;
				}
				console.log("Alarms RENDERs : ", this.alarm_default);
				this.info 		  = this.alarm_default;
				this.info_compt   = {      			
	      			default : this.alarm_default
	      		};
			}
		}, // created

		computed:{
			alarm_button_label(){
				return this.$ml.get(this.btn_alarm == 'update' ? 'alarm_button_update' : 'alarm_button_save');
			},
		},

		methods:{
			
			actions(act, item, opt){
				if ( act == 'save' ) {
					this.save();
				}
				if ( act == 'update' ){
					this.save();	
				}
				if ( act == 'selects_fields' ) {

					// console.log("sounds se", act, item, opt);
					if (opt == 'sound' && item) {						
						this.$Sounds.play(item);
					}
				}else
				if (act == "check_state") {
					console.log("check_state ", act, item, opt)
					let location_ = location && location.hostname ? location.hostname : '';
					if (this.$google_analytic) {
						// this.$ga.event('Alice-guardian', ' btn status smart event is : ' + item + ' ' + opt + '' + location_ , 'btn_status', 2);
						this.$gtag.event('Alice-guardian', { 
					    	method: 'Google', 			    	
					        'event_category': "btn_status",
					        'event_label': ' btn status smart event is : ' + item + ' ' + opt + '' + location_,
					        'value': 2,
					    });
					}
					if (!item) {
						let temp = this.$Helper.get_local("check_status_sm_evt");
						if (!temp) {
							temp = [];
						}
						temp.push({
							user  : this.$store.state.auth.user.user,
							state : item,
							date  : new Date(),
							opt, 					
							location_,			
						})
						this.$Helper.set_local("check_status_sm_evt", temp);
					}

				}else if (act == "active_rule") {
					this.info.is_active_rules = item;
				}
			}, // actions

			
			receive_info(item){
				if (item) {

					if (item.act == 'render_compt') {
						let msg 	= "_registered",
							color 	= "success";

						// console.log("RENDER COMPT ************** ", item )

						if (item.opt && this.info_panels[item.opt]){
							if (item.opt  == 'rules') {
								this.show.btn_show = item.value ? true : false;

							}

							if (!item.value) {			
								// if (item.opt  == 'rules') {

								// }					
								msg 	= "_required_register";
								color 	= "warning"
							}

							this.info_panels[item.opt].text  = item.opt + msg;	
							this.info_panels[item.opt].color = color;
							this.info_panels[item.opt].message = 'updated';
							const timer = setTimeout( () => {
								this.info_panels[item.opt].message = '';
								clearTimeout(timer);
							}, 2000)
							 this.info_panels[item.opt].color_msg = color;
							// console.log(this.info_panels[item.opt] , " **************************** RESULT receive_info")
							if (this.info && this.info[item.opt]) {
								this.info[item.opt] = item.value;
							}
							
						}
					}
				}else{
					console.log("No exist info in item receive")
				}
			},

			get_list(ID){
				const api = this.$URL + '/api/v1/alarm/' + ID;
				this.loading = true;
				this.$axios.get(api).then( res => {
					console.log("Get Alarm",res)
					let items = res.data;
					this.render_info(items);
					this.btn_alarm  	= 'update';
					this.show.btn_show 	= true;
					this.loading 		= false;

				}).catch( er => {
					console.log("Error get Alarm : ", er);
					this.loading 	= false;
				})
			}, // get list


			save(){
				if (this.btn_alarm == "update") {
					if (!this.$store.getters["auth/permission"](this.$route.name || "smart_event", "can_edit", "smart_event")) {
						this.$EventBus.$emit("notifications_modal",{
							type  	: "warning",
							message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("smart_event"),
						})
						return false
					}
				}else{

					if (!this.$store.getters["auth/permission"](this.$route.name || "smart_event", "can_add", "smart_event")) {
						this.$EventBus.$emit("notifications_modal",{
							type  	: "warning",
							message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get("smart_event"),
						})
						return false
					}

				}
				this.check_info(false);				
				console.log("INFO SAVE ", this.info);
				let info_up = this.info,
					option  = 'post',
					ID 		= '';
				
				let list_format = [];
				this.loading 	= true;
				if (this.btn_alarm == 'update') {
					option = 'put';
						console.log(this.info_item, this.info,"UPDATE ALARM")
					if (this.info && this.info.id) {
						ID = '/' + this.info.id
					};
				}else{

					if (info_up && info_up.devices && info_up.devices.length > 0 && Array.isArray(info_up.devices)) {
						info_up.devices.forEach( (dev) => {
							if (dev.deviceId && dev.state) {
								list_format.push({
									deviceId : dev.deviceId,
									points   : dev.points,
									schedule : dev.schedule,
									state 	 : dev.state,
									alarmId  : dev.alarmId ? dev.alarmId : null,
									id 		 : dev.id_detail ? dev.id_detail : null, 
								})
							}

							info_up.devices = list_format;
						}) // devices
					} // 
					else if(info_up && info_up.devices && !Array.isArray(info_up.devices)){						
						for (let i in info_up.devices){
							if (info_up.devices[i].deviceId && info_up.devices[i].state){
								list_format.push({
									deviceId : info_up.devices[i].deviceId,
									points   : info_up.devices[i].points,
									schedule : info_up.devices[i].schedule,
									state 	 : info_up.devices[i].state,
									alarmId  : info_up.devices[i].alarmId ? info_up.devices[i].alarmId : null,
									id 		 : info_up.devices[i].id_detail ? info_up.devices[i].id_detail : null, 
								})
							}
						}
						info_up.devices = list_format;
					}
					if (info_up && info_up.rules && !Array.isArray(info_up.rules)) {
						let temp_rul = info_up.rules;
						let tem_arr = []
						for (let j in temp_rul){
							tem_arr.push(temp_rul[j]);
						}  
						info_up.rules = tem_arr;
					}
				}
				

				const api = this.$URL + '/api/v1/alarm' + ID;

				this.$axios[option](api, info_up).then( res => {
					console.log(" RES " + option + " alarm : ", res);
					this.$EventBus.$emit('notifications_modal', {
						'type'  : this.btn_alarm + 'd',
						message : "Alarm"
					})
					this.loading 	= false;
					
					this.$router.push("smart_event");
					if (option == 'post') {
						this.$SmartEvent.set('add_item', { ...res.data });
					}

					localStorage.removeItem("rule_alarm");
					localStorage.removeItem("devices_alarm");
					localStorage.removeItem("action_alarm");
					localStorage.removeItem("settings_alarm");
				
				}).catch( er => {
					console.log( " Error " + option + " alarm : ", er);
					this.loading 	= false;
					this.$EventBus.$emit('notifications_modal', {
						type  	: 'error',
						message : this.btn_alarm == 'save' ? 
									'saving the information' : 
									'updating the information'
					})
					const timer = setTimeout(()=>{

						this.$EventBus.$emit('notifications_modal', {
							type  	: 'error',
							message : er
						});
						clearTimeout(timer);
					}, 3000)
				})
			}, // save

			render_device_default(check = [], item){
				return this.$Format.format_devices_points(check, item);
			}, // render device default

			render_info(item){
				if (item){
					let vm 			 = this,
						info_down 	 = {},
						item_temp	 = item;
					let list_comp 	 = [
						'device_alarm', 
						'rule_alarm',
						'action_alarm'
					];

					let points_temp = this.default_points;
					let schedule  	= {
						"interval" 	: ["daily"],
						"start" 	: "00:00",
						"end" 		: "23:59",
						"timeZone"	: this.$timezone
					};

					let temp_local = this.$Helper.get_local("settings_alarm");
					let check_local = false;

					// check if exist same id with changes in storage
					if (temp_local) {
						if (temp_local.id == item_temp.id){
							check_local = true; // if true dont process changes

						}
					}	
					// console.log("object ITEM before ***********+ ",item_temp)
					if (item_temp && !item_temp.state) {
						this.actions("check_state", item_temp.state, 'get');
					}

					// set list device default on get info
					let list 		= this.$store.getters['Devices/list'];
					let list_dev    = [];
					// console.log("CHECK DEVICES ", list)
					if (list && list.length === 0) {
						list = this.$Helper.get_local('list_devices');
					}
					if (list && list.length > 0 ){
						list.forEach( dev => {

							list_dev[dev.deviceId] ={
								name : dev.name,
								type : dev.type ? dev.type : 'IP CAM',
							};
						})
					}
					for (let ar_item in item_temp) {
						// console.log("object ITEM ***********+ ", ar_item)
						// console.log(typeof item_temp[ar_item])
						
						// set changes in storage and variables
						if (typeof item_temp[ar_item] == 'string'  || 
							typeof item_temp[ar_item] == 'boolean' ||
							typeof item_temp[ar_item] == 'number'){
							
							// Convert frequency to number if it's a string
							if (ar_item === 'frequency' || ar_item === 'smart_event_cooldown_seconds') {
								info_down[ar_item] = parseInt(item_temp[ar_item]) || 0;
							} else {
								info_down[ar_item] =  item_temp[ar_item];
							}
						
						}
						if (typeof item_temp[ar_item] == 'object'){

							if (true/*!check_local*/){ 
								let key_local = ar_item.split("tail_")[1]; 		
								if (key_local){
									// let local = vm.$Helper.get_local(key_local);

									if (key_local == 'device_alarm') {
										let device_temp = item_temp[ar_item];
										let list_ids 	= [];
										if (device_temp && device_temp.length > 0){
											device_temp.forEach( (dev) => {
												if (dev && dev.detail_roi_device && dev.detail_roi_device.length > 0){
													// console.log(dev.detail_roi_device , "DETA L DEVCE")
													dev.points = dev.detail_roi_device;
													// Detail_roi_device_alarmId;
												}else{
													dev.points = points_temp;
												}
												if (dev.detail_schedule_device && dev.detail_schedule_device.length > 0){
													dev.schedule = dev.detail_schedule_device[0];
												}else{
													dev.schedule = schedule;
												}
												if ( list_dev && list_dev[dev.deviceId]){
													dev.name = list_dev[dev.deviceId].name;
													dev.type = list_dev[dev.deviceId].type
												}
												delete dev.detail_roi_device;
												delete dev.detail_schedule_device;
												list_ids.push(dev.deviceId)
											});
											
											// render devices its not in list
											let temp_list_complet = this.render_device_default(list_ids, { 
												alarmId : item_temp.id ?  item_temp.id : null 
											})
											if (temp_list_complet && temp_list_complet.length > 0) {
												device_temp = device_temp.concat(temp_list_complet);
											}

 											// set devices
											info_down["devices"] = device_temp;
											this.receive_info({
												act   : 'render_compt',
												opt   : "devices",
												value : device_temp 
											})
										}else{
											// info_down["devices"] =
											// 
											console.log("Not found DEVICES in RES get alarms")

										}

										// info_down[ar_item] = item_temp[ar_item]
									}else if(key_local == 'action_alarm'){ // actions
										if (item_temp[ar_item] && item_temp[ar_item].length > 0){

											info_down["actions"] = item_temp[ar_item][0];
											this.receive_info({
												act   : 'render_compt',
												opt   : "actions",
												value : item_temp[ar_item][0] 
											})
										}else{
											console.log("Not found ACTIONS in RES get alarms")
										}

									}else{ // rules

										if (item_temp[ar_item] && item_temp[ar_item].length > 0){
											item_temp[ar_item].forEach( (rul) => {												
												if (ar_item == "Detail_motion_alarm" ){
													rul.analytic = "motion";
												}
								if (ar_item == "Detail_rule_face__alarm") {
										rul.analytic = "face";
								}
								if (ar_item == "Detail_rule_lpr__alarm") {
										rul.analytic = rul.type || 'lpr';
								}
												if (ar_item == "Detail_rule_obj_alarm") {
													rul.analytic = "object";
												}
												if (ar_item == "Detail_rule_action_alarm") {
													rul.analytic = "actions";
												}
											}); // forEach
											if (info_down["rules"] && info_down["rules"].length > 0){
												info_down["rules"] = info_down["rules"].concat(item_temp[ar_item]);
											}else{
												info_down["rules"] = item_temp[ar_item];
											}
											

										}

									}
								}
								/*if (temp) {
									let obj = ar_item.split("_")[0];
								}*/
							} // validate
							
						} // object
					} // for in

					if (info_down && info_down.rules && info_down.rules.length > 0){
						this.receive_info({
							act   : 'render_compt',
							opt   : "rules",
							value : info_down.rules 
						})
					}
					this.info 		= info_down;
					this.info_compt = { 
						default : info_down
					};
					console.log("RESULT INFO DOWN : ", info_down)
				} // item
			}, // render info


			check_info(is_default = true){
				let vm 			 = this,
					temp_default = this.alarm_default;
				let list_comp 	 = [
					'device_alarm', 
					'rule_alarm',
					'action_alarm'
				];
					// 'schedule_alarm',

				list_comp.forEach( (ar_key) =>{
					let temp = vm.$Helper.get_local(ar_key);
					if (temp) {
						let obj = ar_key.split("_")[0];
						console.log("Check local****************** : " , obj, temp);
						obj += 's';
						if (obj == 'device'){
							temp_default["devices"] = temp;
						}else{

							temp_default[obj] = temp;
						}
						vm.receive_info({
							act   : 'render_compt',
							opt   : obj,
							value : temp 
						})

					}
				});
				if (is_default) {
					this.alarm_default = temp_default;
				}
			}, // check_info

		}, // methods


		mounted(){
		
		}, // mounted

		beforeDestroy: function(){
			/*if (localStorage.getItem("settings_alarm")) {
				localStorage.setItem("settings_alarm_temp", localStorage.getItem("settings_alarm"))
			}*/
			
			if (this.info_local) {
				console.log("SmartEvent : ",this.info_local)
				this.$SmartEvent.set('update_item', this.info_local);
				
			}
		}, // beforeDetroy
	};
</script>
